import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="app-header">
      <div className="app-header-inner">
        <div className="app-breadcrumb">
          <a href="https://yakizakana.net/" className="app-brand">
            yakizakana.net
          </a>
          <span className="app-sep">/</span>
          <Link to="/" className="app-service">
            WalkMLB
          </Link>
        </div>
        {user ? (
          <div className="app-header-actions">
            <Link to="/mypage" className="app-login-btn app-login-btn--outline">
              マイページ
            </Link>
            <button
              onClick={logout}
              className="app-login-btn app-login-btn--outline"
            >
              ログアウト
            </button>
          </div>
        ) : (
          <a href="https://yakizakana.net/login" className="app-login-btn">
            ログイン
          </a>
        )}
      </div>
    </header>
  );
}
